import React, { type ReactNode } from 'react';
import ComponentWithAnalytics from '@jira/platform__analytics-web-react/src/utils/component-with-analytics.tsx';
import type { WithAnalyticsEventsProps } from '@atlaskit/analytics-next/withAnalyticsEvents';
import { Link as RouterLink } from '@atlassian/react-resource-router';

type LinkProps = {
	children: ReactNode;
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	createAnalyticsEvent?: any;
	[key: string]: unknown;
};

function Link(props: LinkProps) {
	const { children, ...rest } = props;

	delete rest.createAnalyticsEvent;

	return <RouterLink {...rest}>{children}</RouterLink>;
}

const LinkWithAnalytics: React.FC<
	Omit<
		{
			[x: string]: unknown;
			children: ReactNode;
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
			createAnalyticsEvent?: any;
		},
		keyof WithAnalyticsEventsProps
	>
> = ComponentWithAnalytics('link', {
	onClick: 'clicked',
})(Link);

export default LinkWithAnalytics;
